<template>
  <div>
    <div>
      <span>商品编码：</span>
      <span>{{data.goodsCode}}</span>&nbsp;&nbsp;&nbsp;
      <span>商品名称：</span>
      <span>{{data.goodsName}}</span>
    </div>
    <div style="text-align: right;">
      <select-year v-model="year" @change="yearChange" size="mini"></select-year>
    </div>
    <template v-if="monthData">
      <div class="chart-canvas" ref="chartEl" v-loading="monthData.length === 0"></div>
    </template>
    <template v-else>
      <div class="no-data">暂无数据</div>
    </template>
  </div>
</template>

<script>
import selectYear from './selectYear'
export default {
  components: {selectYear},
  props: ['data'],
  data() {
    return {
      year: null,
      monthData: []
    }
  },
  computed: {
    chartData() {
      let monthStr = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
      let XAxisData = this.monthData.map(v=>v.time);
      let YAxisData = this.monthData.map(v=>v.saleNum);
      let option = {
        grid: {
          top: '10%',
          left: '10%',
          right: '10%'
        },
        xAxis: {
          type: 'category',
          data: XAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: YAxisData,
          type: 'bar',
          showBackground: true,
          backgroundStyle: {
            color: 'rgba(220, 220, 220, 0.3)'
          },
          color: '#24c69a',
          barWidth: 15,
          label: {
            show: true,
            position: 'top',
            formatter: param => {
              return this.numberFormat(param.data)
            }
          }
        }]
      };
      return option
    }
  },
  mounted() {
    this.year = this.data.planTime.substring(0,4);
    this.$nextTick(_=>{
      this.init();
    })
  },
  methods: {
    init() {
      let data = {
        goodsCode: this.data.goodsCode,
        storeId: this.data.storeId,
        year: this.year
      };
      this.$q.preSalePlan.goodsHistorySalesNum({data})
        .then(res=>{
          let chartEl = this.$echarts.init(this.$refs['chartEl']);
          if(res && res.success && res.data) {
            this.monthData = res.data;
            this.$nextTick(_=>{
              chartEl.setOption(this.chartData);
            })
          }else{
            this.monthData = null;
            chartEl.dispose();
          }
        })
    },
    yearChange() {
      this.monthData = [];
      this.init();
    }
  }
}
</script>

<style lang="stylus" scoped>
  .chart-canvas
    width 100%
    height 300px
  .no-data
    text-align center
    color #999999
    padding 40px 0
</style>